// PaginationInfo.jsx
import React from "react";
import { elakayPluralRule } from "./dataElakay";

const PaginationInfo = (props) => {
  const { skip, limit, siseProduct, infoSource, prodCat } = props;

  return (
    <>
      <style>{`
        /* ===== PaginationInfo (PREFIX: paginationinfo-) ===== */
        .paginationinfo-pagination-info-premium{
          background: linear-gradient(135deg,
            rgba(0, 115, 153, 0.08) 0%,
            rgba(0, 164, 216, 0.05) 100%
          );
          border-radius: 12px;
          padding: 1rem 1.5rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 4px 12px rgba(0, 115, 153, 0.1);
          transition: all 0.3s ease;
        }

        .paginationinfo-pagination-info-premium:hover{
          box-shadow: 0 6px 16px rgba(0, 115, 153, 0.15);
          transform: translateY(-2px);
        }

        .paginationinfo-pagination-info-premium h5{
          margin: 0;
          color: #1e293b;
          font-weight: 700;
          font-size: 1.125rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .paginationinfo-pagination-info-premium h5::before{
          content: "📊";
          font-size: 1.25rem;
        }

        @media (max-width: 768px){
          .paginationinfo-pagination-info-premium{
            padding: 0.875rem 1rem;
          }
          .paginationinfo-pagination-info-premium h5{
            font-size: 1rem;
          }
        }

        @media (prefers-reduced-motion: reduce){
          .paginationinfo-pagination-info-premium{
            transition: none !important;
          }
          .paginationinfo-pagination-info-premium:hover{
            transform: none !important;
          }
        }

        .paginationinfo-pagination-info-premium:focus-visible{
          outline: 3px solid #00a4d8;
          outline-offset: 2px;
        }
      `}</style>

      <div className="paginationinfo-pagination-info-premium">
        <h5>
          {prodCat}{" "}
          {(parseInt(skip) - parseInt(limit)) + parseInt(limit) + 1} -{" "}
          {parseInt(skip) + parseInt(limit) > parseInt(siseProduct)
            ? parseInt(siseProduct)
            : parseInt(skip) + parseInt(limit)}{" "}
          {infoSource.language(infoSource, "label", "of")}{" "}
          {parseInt(siseProduct)}{" "}
          {elakayPluralRule(siseProduct) === "one"
            ? infoSource.laguangeElakay("label", infoSource.languageAPI).item
            : infoSource.laguangeElakay("label", infoSource.languageAPI).items}
        </h5>
      </div>
    </>
  );
};

export default PaginationInfo;